function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#AD91FF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 4.9h.72c.013.005.026.015.038.016.261.015.522.023.782.044.466.037.93.101 1.385.253.377.126.73.322 1.018.707.038.05.057.1.057.177-.002 2.565-.001 5.13-.001 7.696v.107c-.018-.007-.025-.008-.031-.012-.078-.056-.157-.11-.234-.17a3.81 3.81 0 00-1.973-.803c-.51-.053-1.023-.07-1.534-.101-.07-.005-.142-.001-.22-.001v-.15-7.627c0-.046-.005-.09-.007-.136M13.78 4.9h.72c-.002.045-.007.09-.007.135v7.63c0 .044-.003.088-.004.136h-.077a12.62 12.62 0 00-1.784.118 3.978 3.978 0 00-1.863.79c-.084.064-.17.123-.265.191v-.107c0-2.569 0-5.138.002-7.707 0-.051.02-.115.045-.15.147-.207.319-.366.509-.484.33-.205.68-.304 1.035-.375.506-.1 1.015-.14 1.526-.158.054-.002.108-.013.162-.019"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 5.9h.983v8.114h.12c.61.012 1.22.01 1.828.039.717.033 1.434.105 2.121.374.316.123.618.295.925.446.01.004.016.018.023.027h-6v-9zM11.5 14.9c.006-.01.011-.022.019-.028.5-.36 1.027-.598 1.584-.702a9.748 9.748 0 011.686-.148l.799-.008h.093V5.9h.819v9h-5z"
})))));